import React, { createContext, useReducer } from 'react';
// import ReactDOM from "react-dom";

const initialState = {
    loggedIn: false,
    loading: true,
    language: 'es',
    configData: {},
    applications: []
};
const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
    const [state, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case 'REQUEST_LOGIN':
                return {
                    ...state,
                    loading: true,
                };
            case 'LOGIN_SUCCESS':
                return {
                    ...state,
                    loading: false,
                    loggedIn: true
                };
            case 'LOGIN_FAIL':
                return {
                    ...state,
                    loading: false,
                    loggedIn: false
                };
            case 'LOGOUT':
                return {
                    ...state,
                    loggedIn: false
                };
            case 'SET_CONFIG':
                return {
                    ...state,
                    configData: action.payload
                };
            case 'SET_APPLICATIONS':
                return {
                    ...state,
                    applications: action.payload
                };
            default:
                throw new Error();
        };
    }, initialState);

    return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
export const JSONContext = createContext();